module.exports = __webpack_public_path__ + "static/media/repeat-illustration.0d52bc5f.png";